module.exports = __webpack_public_path__ + "static/media/smile-neutral.f46981d4.svg";